/**
 * React Query Client — 별도 모듈 (2026-06-14)
 *
 * 이유 (순환 import 방지):
 * - main.jsx 가 App 을 import
 * - App → routes → 페이지 → authStore
 * - authStore 가 main.jsx 의 queryClient import 하면 → 순환
 *
 * 해결: 독립 모듈로 분리. main.jsx + authStore 둘 다 안전하게 import 가능.
 *
 * 보안 (회사 격리):
 * - logout/login 시 queryClient.clear() 호출 — cross-user 캐시 leak 차단
 * - admin → maker 전환 시 admin 의 27건 캐시가 maker 화면에 표시되는 버그 차단
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
